import { render, staticRenderFns } from "./LinklView.vue?vue&type=template&id=58252657"
import script from "./LinklView.vue?vue&type=script&lang=js"
export * from "./LinklView.vue?vue&type=script&lang=js"
import style0 from "./LinklView.vue?vue&type=style&index=0&id=58252657&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports